<!-- 企业级-业务领域-支付记录 -->
<template>
  <div class="mainArea CTOpenLog">
      
      <div class="searchDiv mt20">
        <div>
          <div class="dib"><el-input placeholder="请输入设备ID" v-model="keyword.device_id" clearable></el-input></div>
          <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
        </div>
      </div>
      <div class="tabList">
        <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="type" label="设备类型"></el-table-column>
          <el-table-column prop="device_no_id" label="设备ID"></el-table-column>
          <el-table-column prop="device_name" label="设备名称"></el-table-column>
          <el-table-column prop="user_id" label="操作账号"></el-table-column>
          <el-table-column prop="" label="操作人姓名"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == '1'">开门成功</span>
              <span v-if="scope.row.status == '0'">开门失败</span>
            </template>
          </el-table-column>
          <el-table-column prop="open_time" label="时间"></el-table-column>
        </el-table>
      </div>
      <div class="paging" v-if="total>page">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          :page-size="page"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { bussinessApi,userApi } from "../../../../static/js/api.js"

  export default {
    name: 'CTOpenLog',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          device_id:'',
        },
        configList:[],//审核记录列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

      };
    },
    mounted(){

    },
    created: async function () {
      this.getWarehouse()
    },
    methods: {
      
      //获取快递员列表
      async getWarehouse(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          'device_no_id': that.keyword.device_id,
        }
        let res = await bussinessApi.smzfOpenList(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getWarehouse(val)
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      
    }
  }
</script>

<style lang="scss">
.CTOpenLog{
  .fs25{
    font-size:25px;
  }
  .flexItem{
    flex-grow: 1;
  }
  .flex{
    display: flex;
    align-items: center;
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:block;}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CTactics/CTOpenLog.vue